
import MyModal from "components/MyModal";
import React from "react";
import Button from "../button/Button";
import { AlertDialogActions, AlertDialogButton, AlertDialogDescription, AlertDialogModal, AlertDialogTitle } from "./Theme";

const AlertDialog = ({
  title = "Are you sure?",
  description,
  open,
  onDecline,
  onAccept,
  disabled = false,
  acceptBtnText = "Confirm",
}) => {
  
  if(!open) return null;

  return (
    <MyModal
      className="main__alert-dialog"
      open={open}
      onClose={onDecline}
    >
      <AlertDialogModal>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        <AlertDialogActions>
          <Button
            onClick={onDecline}
            variant="primary-outline"
            size="md"
          >
            <span>Cancel</span>
          </Button>
          <Button
            onClick={onAccept}
            variant="primary"
            size="md"
            disabled={disabled}
          >
            <span>{acceptBtnText}</span>
          </Button>

        </AlertDialogActions>
      </AlertDialogModal>
    </MyModal>
  )
}

export default AlertDialog;